// extracted by mini-css-extract-plugin
export default {"root":"root--39119b2","row":"row--f7a39e4"};